import Vue from 'vue';
import axios, { AxiosRequestConfig, CancelToken } from 'axios';
import { getSessionToken } from '@/helpers/sessionStorage';
export interface HttpRequestOptions {
    timeoutMs?: number;
    cancelToken?: CancelToken;
}

export const DEFAULT_HTTP_TIMEOUT = 90 * 1000;
export const EXTERNAL_STATUS_HTTP_TIMEOUT = 50 * 1000;
export const UPLOAD_HTTP_TIMEOUT = 5 * 60 * 1000;
export default class BaseApi extends Vue {
    public baseUrl: string;
    public apiUrl: string;
    public headers!: any;
    constructor(controllerName: string) {
        super();
        this.baseUrl = process.env.VUE_APP_API_URL as any;
        this.apiUrl = `${this.baseUrl}${controllerName}/`;
        this.headers = {};
       
        // Consulta rápida temporalmente desactivada.
        // let consultaRapida = localStorage.getItem("consultaRapida");
        // if (consultaRapida){
        //     this.allowRequestNoAuth();
        // }
    }
    public serHeader(key: string, value: string) {
        this.headers.set(key, value);
    }
    public allowRequestNoAuth(key = 'x-api-key', value?: string) {
        // Consulta rÃ¡pida temporalmente desactivada.
        // ImplementaciÃ³n previa agregaba el API key a los headers.
    }
    created(){
        this.headers.Authorization = `Bearer ${getSessionToken()}`
    }
    public genericRequest<T>(method: string, url: string = '', data: T | T[], params?: object,
     successCallback: (...params: any) => void = (response) => {
    }, errorCallback: (...params: any) => void = (error) => {
        }, finallyCallback: (...params: any) => void = () => { }, headers: object = this.headers, requestOptions: HttpRequestOptions = {}) {
        this.headers.Authorization = `Bearer ${getSessionToken()}`

        const config: AxiosRequestConfig = {
            method,
            url,
            data,
            params,
            headers,
            timeout: requestOptions.timeoutMs || DEFAULT_HTTP_TIMEOUT,
            cancelToken: requestOptions.cancelToken
        };
        var self = this as any;
        self.$http(config).then(successCallback).catch(errorCallback).then(finallyCallback);
    }
    public genericRequestWithAccessToken<T>(method: string, url: string = '', data: T | T[], params?: object,
     successCallback: (...params: any) => void = (response) => {
    }, errorCallback: (...params: any) => void = (error) => {
        }, finallyCallback: (...params: any) => void = () => { }, headers?: object, requestOptions?: HttpRequestOptions) {
        // Consulta rÃ¡pida temporalmente desactivada.
        // ImplementaciÃ³n previa enviaba el API key. Se mantiene la firma
        // por compatibilidad y ahora cae al request normal sin headers extra.
        this.genericRequest(
            method,
            url,
            data,
            params,
            successCallback,
            errorCallback,
            finallyCallback,
            headers || this.headers,
            requestOptions
        );
    }
    public request<T>(method: string, action: string = '', data: T | T[], params?: object, successCallback?: (response: any) => void, errorCallback?: (...params: any) => void, finallyCallback?: (...params: any) => void, headers?: object, requestOptions?: HttpRequestOptions) {
        this.genericRequest(method, this.apiUrl + action, data, params, successCallback, errorCallback, finallyCallback, headers, requestOptions);
    }
    public requestWithAccessToken<T>(method: string, action: string = '', data: T | T[], params?: object, successCallback?: (response: any) => void, errorCallback?: (...params: any) => void, finallyCallback?: (...params: any) => void, headers?: object, requestOptions?: HttpRequestOptions) {
        // Consulta rÃ¡pida temporalmente desactivada.
        this.genericRequestWithAccessToken(method, this.apiUrl + action, data, params, successCallback, errorCallback, finallyCallback, headers, requestOptions);
    }
    public do<T>(method: string, controllerNameAndAction: string = '', data: T | T[], params: object, successCallback?: (response: any) => void, errorCallback?: (...params: any) => void, finallyCallback?: (...params: any) => void, requestOptions?: HttpRequestOptions) {
        this.genericRequest(method, this.baseUrl + controllerNameAndAction, data, params, successCallback, errorCallback, finallyCallback, this.headers, requestOptions);
    }
}
